<template>
    <d2-container :filename="filename">
        <d2-crud
                :columns="columns"
                :data="data"
                :loading="loading"
                title="摄影列表"
                :pagination="pagination"
                :rowHandle="rowHandle"
                @row-remove="handleCustomDelete"
                :form-options="formOptions">
            <el-button slot="headerButton" @click="addData">
                <d2-icon name="plus"></d2-icon>
            </el-button>
            <el-button slot="headerButton" @click="getData">
                <d2-icon name="refresh"></d2-icon>
            </el-button>
        </d2-crud>
        <template slot="footer">
            www.heanny.cn
        </template>
    </d2-container>
</template>

<script>
    import UserImg from "@/pages/components/userImg.vue"
    import PhotoEditor from "@/pages/components/photoEditor.vue"

    export default {
        components: {UserImg, PhotoEditor},
        data() {
            return {
                filename: __filename,
                loading: false,
                pagination: {
                    pageSize: 10,
                    layout: 'prev, pager, next, total'
                },
                columns: [
                    {
                        title: 'ID',
                        key: 'id'
                    },
                    {
                        title: '标题',
                        key: 'title'
                    }, {
                        title: '图片',
                        key: 'imgurl',
                        component: {
                            // name: "div",
                            render: function (h, row) {
                                return h("img", {
                                    attrs: {
                                        src: row.imgurl ? "//cdn.heanny.cn/Photo/thumb/" + row.imgurl : "//cdn.heanny.cn/Photo/moren.png",
                                        height: '50px',
                                        width: '50px',
                                    }
                                })
                            }
                        }
                    },
                    {
                        title: '作者',
                        key: 'user'
                    },
                    {
                        title: '时间',
                        key: 'time'
                    },
                    {
                        title: '显示',
                        key: 'show',
                        formatter(row, index, val) {
                            const value = parseInt(val)
                            if (value === 1) {
                                return '显示'
                            } else if (value === 0) {
                                return '隐藏'
                            } else {
                                return '暂未设置'
                            }
                        }
                    },
                    {
                        title: '编辑',
                        key: 'editor',
                        component: {
                            render: function (h, row) {
                                return h(PhotoEditor, {
                                    attrs: {
                                        row: row,
                                    }
                                })
                            }
                        },

                    },

                ],
                data: [],
                formOptions: {
                    labelWidth: '80px',
                    labelPosition: 'left',
                    saveLoading: false
                },
                rowHandle: {
                    columnHeader: '删除',
                    remove: {
                        text: '',
                        icon: 'el-icon-delete',
                        size: 'small',
                        fixed: 'right',
                        confirm: true,
                    },
                },
            }
        },
        methods: {
            view() {
                this.$store.dispatch('d2admin/page/open', {
                    name: 'photo-change',
                })
                location.href = '/#/photo/change/' + this.row.id
            },
            addData() {
                this.$store.dispatch('d2admin/page/open', {
                    name: 'photo-add',
                })
                location.href = '/#/photo/add'
            },

            handleCustomDelete({index, row}, done) {
                this.$request({url: 'delPhotoById.do', data: {id: row.id}}).then(res => {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    done()
                }).catch(err => {
                    this.$message.error('删除失败');
                })
            },
            getData() {
                const _this = this
                this.loading = true
                this.$request({url: "getPhotos.do",}).then(res => {
                    _this.data = res
                    _this.loading = false
                })
                    .catch((error) => {
                        this.msg = error
                        _this.loading = false

                    })
            }
        }, created: function () {
            this.getData()
        }
    }
</script>
<style>
    .time {
        font-size: 13px;
        color: #999;
    }

    .bottom {
        margin-top: 13px;
        line-height: 12px;
    }

    .button {
        padding: 0;
        float: right;
    }

    .image {
        width: 100%;
        display: block;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }
</style>
<style>
    /*.el-card {*/
    /*height: 250px;*/
    /*}*/

    .el-card span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .time {
        font-size: 13px;
        color: #999;
    }

    .bottom {
        margin-top: 13px;
        line-height: 12px;
    }

    .button {
        padding: 0;
        float: right;
    }

    .image {
        width: 100%;
        display: block;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }
</style>

<style>
    .time {
        font-size: 13px;
        color: #999;
    }

    .bottom {
        margin-top: 13px;
        line-height: 12px;
    }

    .button {
        padding: 0;
        float: right;
    }

    .image {
        width: 100%;
        display: block;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }
</style>
